import { useNavigate } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'

function AdminDashboardPage() {
    const navigate = useNavigate()

    const handleLogout = async () => {
        await fetch('/api/admin/logout', { method: 'POST' })
        navigate('/admin/login')
    }

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header variant="default" />

            <main className="flex-grow flex items-center justify-center p-6 py-12">
                <div className="max-w-2xl w-full">

                    <div className="text-center mb-10">
                        <div className="inline-block p-3 bg-yubico-green-50 rounded-2xl mb-4">
                            <i className="iconoir-shield-check text-yubico-green-400 text-3xl"></i>
                        </div>
                        <h2 className="text-3xl font-bold text-gray-900">Admin Portal</h2>
                        <p className="text-gray-500 mt-2">What would you like to do?</p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                        {/* Shipping card */}
                        <button
                            onClick={() => navigate('/admin/shipping')}
                            className="group bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-left hover:border-yubico-green-400 hover:shadow-xl transition-all transform hover:scale-[1.02]"
                        >
                            <div className="inline-block p-3 bg-yubico-green-50 rounded-xl mb-5 group-hover:bg-yubico-green-100 transition-colors">
                                <i className="iconoir-delivery-truck text-yubico-green-400 text-2xl"></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">Request Shipping</h3>
                            <p className="text-gray-500 text-sm">Submit a new YubiKey shipment request for approval</p>
                        </button>

                        {/* Report card */}
                        <button
                            onClick={() => navigate('/admin/report')}
                            className="group bg-white rounded-2xl shadow-lg border border-gray-100 p-8 text-left hover:border-yubico-green-400 hover:shadow-xl transition-all transform hover:scale-[1.02]"
                        >
                            <div className="inline-block p-3 bg-yubico-green-50 rounded-xl mb-5 group-hover:bg-yubico-green-100 transition-colors">
                                <i className="iconoir-stats-report text-yubico-green-400 text-2xl"></i>
                            </div>
                            <h3 className="text-xl font-bold text-gray-900 mb-2">Shipment Report</h3>
                            <p className="text-gray-500 text-sm">View and export the audit trail of all shipment requests</p>
                        </button>
                    </div>

                    <div className="text-center">
                        <button
                            onClick={handleLogout}
                            className="text-sm text-gray-400 hover:text-gray-700 font-medium transition-colors"
                        >
                            <i className="iconoir-log-out text-sm mr-1"></i>
                            Sign out
                        </button>
                    </div>

                </div>
            </main>

            <Footer variant="default" />
        </div>
    )
}

export default AdminDashboardPage
